import { reactive } from 'vue'

/**
 * The confirmation the tasks listing shows before turning the picked tasks into
 * incoming requests - how many were picked, and what to do once the user says yes.
 */
export function useConvertDialog () {
  const state = reactive({
    isOpen: false,
    taskCount: 0,
    onConfirm: null
  })

  const open = (config) => {
    const { taskCount, onConfirm } = config || {}
    state.taskCount = Number(taskCount) || 0
    state.onConfirm = onConfirm || null
    state.isOpen = true
  }

  const close = () => {
    state.isOpen = false
    state.taskCount = 0
    state.onConfirm = null
  }

  return {
    state,
    open,
    close
  }
}
